// extracted by mini-css-extract-plugin
module.exports = {"qr-codes-container":"qr-codes_qr-codes-container__3IQal"};